export default "__VITE_ASSET__d52676fc__"